import { createFileRoute, redirect } from '@tanstack/react-router';
import { ReactElement } from 'react';

import { SignInForDemoPage } from '@/features/auth/sign-in-for-demo';
import { isSessionAuthenticated } from '@/lib/auth-session';

export const Route = createFileRoute('/sign-in')({
	beforeLoad: ({ context: { msal } }) => {
		if (isSessionAuthenticated(msal)) {
			throw redirect({ to: '/dashboard', throw: true });
		}
	},
	component: RouteComponent,
});

function RouteComponent(): ReactElement {
	return <SignInForDemoPage />;
}
